import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Material from '@primeuix/themes/material';
import { definePreset } from '@primeuix/themes'
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { attachBearerTokenInterceptor, handleUnauthorizedResponseInterceptor } from './services/security/auth.interceptor';
import { attachClientAppHeaderInterceptor } from './services/security/client-app.interceptor';
import { environment } from '@/environments/environment';
import { provideAuth0 } from '@auth0/auth0-angular';

const MyTheme = definePreset(Material, {
  components: {
    datatable: {
      headerCell: {
        selectedColor: '#004d99'
      },
      sortIcon: {
        hoverColor: '#002b5c'
      },
    },
    paginator: {
      navButton: {
        selectedBackground: '#004d99',
        selectedColor: '#fff'
      }
    },
    checkbox: {
      icon: {
        checkedColor: '#fff',
      },
      root: {
        checkedBackground: '#2f5cb6',
        checkedHoverBackground: '#2f5cb6',
        checkedBorderColor: '#2f5cb6',
        checkedHoverBorderColor: '#2f5cb6'
      }
    },
    tabs: {
      activeBar: {
        background: '#ff0000'
      },
      tab: {
        color: '#2f5cb6',
        activeColor: '#002b5c',
        activeBorderColor: '#ff0000',
        hoverBorderColor: '#ff0000'
      }
    }
  }
});


export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([
      attachClientAppHeaderInterceptor,
      attachBearerTokenInterceptor,
      handleUnauthorizedResponseInterceptor])),
    provideAnimationsAsync(),
    provideToastr({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true
    }),
    providePrimeNG({
      theme: {
        preset: MyTheme,
        options: {
          darkModeSelector: false
        }
      },
      ripple: false
    }),
    provideAuth0(environment.auth),
  ]
};
